<template>
  <portal-target name="root-container"/>
</template>

<script>
  import {PortalTarget} from 'portal-vue'

  export default {
    name: "portal-root-container",
    components:{
      PortalTarget,
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/portal-root-container.vue